import ProfileItemForm from "./ProfileItemForm";
import ProfileSchoolRow from "../../profiles/components/ProfileSchoolRow";
import React from "react";

export default class SchoolForm extends ProfileItemForm {

    static ItemType = 'School'

    static FormClass = 'talent-role-form add-talent-form add-school-form '
    static ShowProfilePreview = true;

    static TypeConfig = {
        icon: 'fa fa-graduation-cap',
        color: TB.config('color.blue')
    }

    getModelFromProps() {
        let model = {
            ...(this.props.model || {})
        };

        if (model.started_at) {
            if(typeof model.started_at === 'string') {
                model.started_at = new Date(model.started_at)
            }
            model.started_at_year = model.started_at.getFullYear();
            model.started_at_month = model.started_at.getMonth() + 1;
        }
        if (model.ended_at) {
            if(typeof model.ended_at === 'string') {
                model.ended_at = new Date(model.ended_at)
            }
            model.ended_at_year = model.ended_at.getFullYear();
            model.ended_at_month = model.ended_at.getMonth() + 1;
        }

        return model;
    }

    async onChange(model) {
        await super.onChange({
            ...model,
            ...this.setDateFromInputs(model, 'started_at'),
            ...this.setDateFromInputs(model, 'ended_at'),
        });

        let errors = {
            ...this.validateDateBeforeToday('started_at', 'Start date'),
            ...this.validateDateAfterDate('ended_at', 'started_at')
        };
        if(errors.ended_at === null) {
            errors = TB.merge(errors,{
                ...this.validateDateBeforeToday('ended_at', 'End date'),
            });
        }

        if (Object.keys(errors).length) {
            this.formRef.current.updateInputsWithError(errors)
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {

        // 'schools.*.name'            => 'required|string|max:255',
        // 'schools.*.earned_degree'   => 'required|string|max:255',
        // 'schools.*.field_of_study'  => 'required|string|max:255',
        // 'schools.*.started_at'      => 'required|date',
        // 'schools.*.ended_at'        => 'nullable|date',

        let {start_date} = this.state.model;
        let endMinDate = start_date || new Date();

        if (start_date && typeof start_date === 'string') {
            endMinDate = Date.parse(start_date);
        }

        return [
            {
                style: styles.fieldSection,
                fields: {
                    name: {
                        type: 'text',
                        label: TB.trans('talent.school_form.school_name_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.school_form.school_name_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    started_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.school_form.start_date_label'),
                        required: false,
                        style: styles.field,
                        maxDate: new Date(),
                        className: 'field hide-input',
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    started_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: {...styles.field,  maxWidth: 110, paddingRight: 0},
                        hideVisibility: !this.props.isEditing && !this.state.model.started_at_month
                    },
                    started_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: parseInt(this.state.model.started_at_month) > 0,
                        labelClassName: 'hide-label',
                        options: this.yearOptions(),
                        style: {...styles.field,  maxWidth: 110},
                        validations: {

                            need_year: ({model}, value) => {
                                if (model.started_at_month && (value === '' || TB.isNaN(value))) {
                                    return 'Year is required with a month'
                                }

                                return true;
                            }
                        },
                        hideVisibility: !this.props.isEditing && !this.state.model.started_at_year
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    ended_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.school_form.end_date_label'),
                        required: false,
                        style: styles.field,
                        className: 'field hide-input',
                        maxDate: new Date(),
                        minDate: endMinDate,
                        columns: 10,
                        hideVisibility: !this.props.isEditing && !this.state.model.ended_at
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    ended_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: {...styles.field,  maxWidth: 110, paddingRight: 0},
                        hideVisibility: !this.props.isEditing && !this.state.model.ended_at
                    },
                    ended_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: parseInt(this.state.model.ended_at_month) > 0,
                        labelClassName: 'hide-label',
                        validations: {

                            need_year: ({model}, value) => {
                                if (model.ended_at_month && (value === '' || TB.isNaN(value))) {
                                    return 'Year is required with a month'
                                }

                                return true;
                            }
                        },
                        options: this.yearOptions(),
                        style: {...styles.field,  maxWidth: 110},
                        hideVisibility: !this.props.isEditing && !this.state.model.ended_at
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    field_of_study: {
                        type: 'text',
                        label: TB.trans('talent.school_form.area_of_study_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.school_form.area_of_study_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            }, {
                style: styles.fieldSection,
                fields: {
                    earned_degree: {
                        type: 'text',
                        label: TB.trans('talent.school_form.earned_degree_label'),
                        maxLength: 255,
                        required: false,
                        placeholder: TB.trans('talent.school_form.earned_degree_placeholder'),
                        style: styles.field,
                        columns: 10,
                    }
                }
            },
        ]
    };
    renderProfilePreview() {
        return (
            <div className="px-4 mx-0 self-start">
                <ProfileSchoolRow school={this.getModelFromProps()}/>
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};